import { render, staticRenderFns } from "./BotTV.vue?vue&type=template&id=1c87e420&scoped=true"
import script from "./BotTV.vue?vue&type=script&lang=js"
export * from "./BotTV.vue?vue&type=script&lang=js"
import style0 from "./BotTV.vue?vue&type=style&index=0&id=1c87e420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87e420",
  null
  
)

export default component.exports